{
    "Profile_Policy_Vitals.partyStats": "FR: Party Stats",
    "Profile_Policy_Vitals.partyDetails": "FR: Party Details",
    "Profile_Policy_Vitals.partyBrokerage": "FR: Brokerage",
    "Profile_Policy_Vitals.partyAssignedTo": "FR: Assigned To",

    "Profile_Policy_Vitals.vitalStats": "FR: Vital Stats",
    "Profile_Policy_Vitals.policyDetails": "FR: Policy Details",
    "Profile_Policy_Vitals.description": "FR: Description",
    "Profile_Policy_Vitals.submissionReference": "FR: Submission Reference",
    "Profile_Policy_Vitals.policyNumber": "FR: Policy Number",
    "Profile_Policy_Vitals.previousPolicyNumber": "FR: Previous Policy Number",
    "Profile_Policy_Vitals.product": "FR: Product",
    "Profile_Policy_Vitals.lineOfBusiness": "FR: Line of Business",
    "Profile_Policy_Vitals.type": "FR: Type",
    "Profile_Policy_Vitals.status": "FR: Status",
    "Profile_Policy_Vitals.lostReason": "FR: Lost Reason",
    "Profile_Policy_Vitals.effectiveDate": "FR: Effective Date",
    "Profile_Policy_Vitals.expiryDate": "FR: Expiry Date",
    "Profile_Policy_Vitals.quoteExpiryDate": "FR: Quote Expiry Date",
    "Profile_Policy_Vitals.bindable": "FR: Bindable",
    "Profile_Policy_Vitals.billingMethod": "FR: Billing Method",

    "Profile_Policy_Vitals.Status.None": "FR: None",
    "Profile_Policy_Vitals.Status.Incomplete": "FR: Incomplete",
    "Profile_Policy_Vitals.Status.Submitted": "FR: Submitted",
    "Profile_Policy_Vitals.Status.Abandoned": "FR: Abandoned",
    "Profile_Policy_Vitals.Status.Accepted": "FR: Accepted",
    "Profile_Policy_Vitals.Status.Quoted": "FR: Quoted",
    "Profile_Policy_Vitals.Status.UnderwritingRequired": "FR: Underwriting Required",
    "Profile_Policy_Vitals.Status.Referred": "FR: Referred",
    "Profile_Policy_Vitals.Status.QuoteIssued": "FR: Quote Issued",
    "Profile_Policy_Vitals.Status.BindRequested": "FR: Bind Requested",
    "Profile_Policy_Vitals.Status.Bound": "FR: Bound",
    "Profile_Policy_Vitals.Status.Issued": "FR: Issued",
    "Profile_Policy_Vitals.Status.Lost": "FR: Lost",
    "Profile_Policy_Vitals.Status.Cancelled": "FR: Cancelled",
    "Profile_Policy_Vitals.Status.QuoteAccepted": "FR: Quote Accepted",
    "Profile_Policy_Vitals.Status.Quoting": "FR: Quoting",

    "Profile_Policy_Vitals.Type.New": "FR: New Business",
    "Profile_Policy_Vitals.Type.Renewal": "FR: Renewal",
    "Profile_Policy_Vitals.Type.Endorsement": "FR: Endorsement",
    "Profile_Policy_Vitals.Type.Cancellation": "FR: Cancellation",
    "Profile_Policy_Vitals.Type.Reinstatement": "FR: Reinstatement",
    "Profile_Policy_Vitals.Type.Audit": "FR: Audit",
    "Profile_Policy_Vitals.Type.TakeUp": "FR: Take Up",
    "Profile_Policy_Vitals.Type.Certificate": "FR: Certificate"
}
